import { AlertTriangle, Loader2 } from 'lucide-react';
import { Card, CardBody } from '@solara/ui-shared';

export function LoadingBlock({ label }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-2 py-12 text-fg-muted">
      <Loader2 className="h-5 w-5 animate-spin" aria-hidden />
      <span className="text-sm">{label ?? 'Loading…'}</span>
    </div>
  );
}

export function ErrorBanner({
  error,
  label,
}: {
  error: unknown;
  label?: string;
}) {
  const msg =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
      ? error
      : 'Request failed';
  return (
    <Card className="rounded-2xl border-danger/30 bg-danger/5">
      <CardBody className="p-4 flex items-start gap-3 text-sm text-danger">
        <AlertTriangle className="h-5 w-5 mt-0.5 shrink-0" />
        <div className="min-w-0">
          <div className="font-medium">{label ?? 'Could not load data'}</div>
          <div className="text-xs opacity-80 break-words">{msg}</div>
        </div>
      </CardBody>
    </Card>
  );
}
